import React from 'react';
import { ClockIcon, ZapIcon, AlertCircleIcon, ShieldAlertIcon } from 'lucide-react';
import { slaInfo } from '../data/mockData';
export function SLAInfo() {
  const expectations = [{
    priority: 'Low',
    icon: ClockIcon,
    color: 'text-gray-600',
    bgColor: 'bg-gray-100',
    resolution: slaInfo.resolutionLow,
    desc: 'Non-urgent requests, general inquiries'
  }, {
    priority: 'Medium',
    icon: ZapIcon,
    color: 'text-blue-600',
    bgColor: 'bg-blue-100',
    resolution: slaInfo.resolutionMedium,
    desc: 'Standard issues affecting single user'
  }, {
    priority: 'High',
    icon: AlertCircleIcon,
    color: 'text-amber-600',
    bgColor: 'bg-amber-100',
    resolution: slaInfo.resolutionHigh,
    desc: 'Significant impact on work, no workaround'
  }, {
    priority: 'Critical',
    icon: ShieldAlertIcon,
    color: 'text-red-600',
    bgColor: 'bg-red-100',
    resolution: slaInfo.resolutionCritical,
    desc: 'System outage, multiple users affected'
  }];
  return <div className="bg-slate-50 py-16 border-t border-slate-200" data-id="element-143">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-144">
        <div className="text-center mb-10" data-id="element-145">
          <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-146">
            What to Expect
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-147">
            Our team is here to help. Here's what you can expect for resolution
            times after submitting a request.
            <span className="block mt-2 font-medium text-slate-700" data-id="element-148">
              First response time for all tickets: {slaInfo.firstResponse}
            </span>
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-149">
          {expectations.map(item => {
          const Icon = item.icon;
          return <div key={item.priority} className="bg-white rounded-xl p-6 border border-slate-200 shadow-sm" data-id="element-150">
                <div className="flex items-center justify-between mb-4" data-id="element-151">
                  <span className="font-bold text-slate-900" data-id="element-152">
                    {item.priority} Priority
                  </span>
                  <div className={`p-2 rounded-lg ${item.bgColor} ${item.color}`} data-id="element-153">
                    <Icon className="w-5 h-5" data-id="element-154" />
                  </div>
                </div>
                <div className="mb-2" data-id="element-155">
                  <span className="text-2xl font-extrabold text-slate-900" data-id="element-156">
                    {item.resolution}
                  </span>
                </div>
                <p className="text-sm text-slate-500" data-id="element-157">{item.desc}</p>
              </div>;
        })}
        </div>
      </div>
    </div>;
}